<div class="confirm-anomalie">
  <h2 class="colorSearch-an" mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content class="mat-typography">

    <mat-form-field appearance="fill" color='accent' class="all-w">
      <mat-label class="purp">Motivazione rifiuto -  {{this.datePipe.transform(showDate, 'dd/MM/yyyy HH:mm:ss')}} </mat-label>
      <textarea id="last-message" matInput [disabled]="true" [value]="showMessage"></textarea>
    </mat-form-field>

    <mat-table [dataSource]="dataSource" [hidden]="!showTable">

      <ng-container matColumnDef="motivazioneRifiuto">
        <mat-header-cell *matHeaderCellDef>
          Motivazione rifiuto
          <mat-icon matTooltip="Clicca sul messaggio scelto per farlo apparire nella textarea" [matTooltipPosition]="'right'" [matTooltipClass]="'tooltip-class-a-capo'" class="val-text">wrap_text</mat-icon> </mat-header-cell>
        <mat-cell [attr.data-label]="'MOTIVAZIONE RIFIUTO'" *matCellDef="let element">
          <p class="motivazioneRif">
            {{element.motivazioneRifiuto}}
          </p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataRifiuto">
        <mat-header-cell *matHeaderCellDef>Data inserimento<br/>motivazione</mat-header-cell>
        <mat-cell [attr.data-label]="'DATA INSERIMENTO MOTIVAZIONE'" *matCellDef="let element">
          {{this.datePipe.transform(element.dataConfermaRifiuto, 'dd/MM/yyyy HH:mm:ss')}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="utenteRifiuto">
        <mat-header-cell *matHeaderCellDef>Utente inserimento<br/> motivazione</mat-header-cell>
        <mat-cell [attr.data-label]="'UTENTE INSERIMENTO MOTIVAZIONE'" *matCellDef="let element">
          {{element.utenteConfermaRifiuto}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let element ; columns: displayedColumns;" (click)="onShowMessage(element.motivazioneRifiuto, element.dataConfermaRifiuto)"></mat-row>

    </mat-table>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
      <p class='cont'>Annulla</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' *ngIf="!showTable" (click)='onShowTab()' cdkFocusInitial>
      <p class='cont'>Mostra tutti</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' *ngIf="showTable" (click)='onShowTab()' cdkFocusInitial>
      <p class='cont'>Nascondi tutti</p>
    </button>
  </mat-dialog-actions>
</div>
